import type { LucideIcon } from "lucide-react";
import { AlertCircle, Check, Minus } from "lucide-react";

import { Alert } from "@krea/shared/design-system/alerts/Alert";
import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";
import { cn } from "@krea/shared/utils";

const DataStatusIndicator = ({
  tooltip,
  isDone,
  notExists,
}: {
  tooltip?: string;
  isDone?: boolean;
  notExists?: boolean;
}) => {
  let className = "bg-red-100 text-black";
  let Icon: LucideIcon = AlertCircle;

  if (notExists) {
    className = "bg-gray-500 text-gray-800";
    Icon = Minus;
  } else if (isDone) {
    className = "bg-green-700 text-white";
    Icon = Check;
  }

  const alertContent = (
    <Alert
      variant="plain"
      className={cn(
        "!mt-0 m-0 flex shrink-0 items-center justify-center rounded-lg p-0 w-8 h-8",
        className,
      )}
    >
      <div className="flex size-full items-center justify-center">
        <Icon className="size-4" />
      </div>
    </Alert>
  );

  if (tooltip) {
    return (
      <ResponsiveTooltip trigger={alertContent}>{tooltip}</ResponsiveTooltip>
    );
  }

  return alertContent;
};

export { DataStatusIndicator };
